<template>
  <l-tela titulo="Usuários">
    <l-consulta
      :colunas="colunas"
      :registros="registros"
      :totalPaginas="paginas"
      @cliqueLinha="abrirAlteracao"
      @buscarPagina="buscar"
    />
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          fab
          large
          fixed
          bottom
          right
          v-bind="attrs"
          v-on="on"
          @click="abrirCadastro"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Adicionar novo usuário</span>
    </v-tooltip>
  </l-tela>
</template>

<script>
import usuarioService from '@/services/usuario.service'
import LoadingMixin from '@/components/Mixins/Loading'
import NotificacaoMixin from '@/components/Mixins/Notificacao'

export default {
  mixins: [LoadingMixin, NotificacaoMixin],
  data() {
    return {
      colunas: [
        {
          text: 'Nome do usuário',
          align: 'start',
          sortable: false,
          value: 'nome',
          width: 500,
        },
        {
          text: 'Login de acesso',
          value: 'login',
        },
        {
          text: 'Contato',
          value: 'contato',
        },
        {
          text: 'Usuário ativo?',
          value: 'ativo',
          mascaraBool: true,
        },
      ],
      registros: [],
      paginas: 0,
    }
  },
  mounted() {
    this.buscar()
  },
  methods: {
    abrirCadastro() {
      this.$router.push({ name: 'rota-usuario-cadastrar' })
    },
    abrirAlteracao(registro) {
      const { _id } = registro
      if (_id) {
        this.$router.push({
          name: 'rota-usuario-alterar',
          params: { usuarioId: _id },
        })
      }
    },
    async buscar(pagina = 1) {
      this.mostrarLoading()
      try {
        const usuarios = await usuarioService.buscaTodos(pagina)
        this.registros = usuarios.lista
        this.paginas = usuarios.pages
      } catch (error) {
        this.mostraNotificacao(error)
      } finally {
        this.fecharLoading()
      }
    },
  },
}
</script>
